<template>
  <div class="new-layout">
    <div class="new-layout-bg">
      <div class="new-content">
        <div  class="title">地平线计划爱心照亮深山之路：150盏太阳能路灯点亮甘洛县沙岱乡</div>
        <div style="color: rgba(80, 80, 80, 0.7);margin-top: 6px">2026年01月21日 13:56 北京</div>
        <div class="content">
          <div class="big-ds">
            【地平线爱心计划】公益新进展 | 150盏路灯点亮大凉山，照亮乡村振兴幸福路
          </div>
          <div class="ds-ct">
            2026年1月19日，由贵州省为爱黔行公益服务中心发起的“地平线计划——点亮乡村公益行”在四川省凉山彝族自治州甘洛县沙岱乡圆满完成物资捐赠与项目验收。150盏太阳能路灯顺利安装并交付使用，为当地5个村庄、约1250名村民的夜间出行与生活带来了温暖与便利。
          </div>
          <img class="new-icon" src="@/assets/new4_imag5.png">

          <div class="big-ds">
            项目背景与实施
          </div>
          <div class="ds-ct">
            “点亮乡村振兴路”公益项目由贵州省为爱黔行公益服务中心统筹实施，旨在通过捐赠太阳能路灯，改善偏远山区照明条件，提升村民生活品质，助力乡村振兴。项目受赠方为四川省甘洛县沙岱乡人民政府，路灯覆盖各布村、阿尺村、舍底村、磨子沟村、妮觉俄洛村共五个村落。
          </div>
          <img class="new-icon" src="@/assets/new4_imag1.png">
          <img class="new-icon" src="@/assets/new4_imag2.png">

          <div class="ds-ct">
            在多家爱心企业——包括Australian Deep Energy Pty Ltd、海选未来、深度电力（江苏）有限公司、扬州柏顺酒店用品有限公司、江苏秉扬电力科技有限公司、扬州维迪能源科技有限公司、新海岸（扬州）绳业有限公司、吴江柏高纺织有限公司、江苏力浦交通照明有限公司的共同支持下，项目顺利完成设备采购、运输与安装工作。
          </div>
          <img class="new-icon" src="@/assets/new4_imag3.png">
          <img class="new-icon" src="@/assets/new4_imag4.png">
          <div class="big-ds">
            专业验收，品质保障
          </div>
          <div class="ds-ct">
            项目完工后，实施单位与受赠方共同开展了系统、规范的现场验收与资料审核。验收内容涵盖设备规格、安装工程、系统性能及文件资料四大类，全部项目均符合标准，验收结果均为合格。
          </div>
          <div class="ds-ct">
            ✅ 设备验收要点：
          </div>
          <div class=" box-xxt2">
            1.太阳能路灯数量：150盏，符合规划
          </div>
          <div class=" box-xxt2">
            2.灯具功率：60W LED，节能高效
          </div>
          <div class=" box-xxt2">
            3.太阳能板转换效率：≥18%，阴雨天仍可持续供电
          </div>
          <div class=" box-xxt2">
            4.电池类型：锂电池，适应-25℃–70℃环境，寿命5年以上
          </div>
          <div class=" box-xxt2">
            5.灯杆材质：热镀锌防腐，设计使用寿命20年
          </div>
          <div class="ds-ct">
            ✅ 安装与性能验收：
          </div>
          <div class="box-xxt2">
            所有路灯安装位置准确、灯杆垂直、接地可靠，具备光控与时控功能，可实现智能亮灯。在试运行期间系统运行稳定，满足每日照明10小时的设计要求。
          </div>
          <div class="big-ds">
            村民受益，温暖落地
          </div>
          <div class="ds-ct">
            沙岱乡人民政府在《执行证明》中表示：“项目已完成实施，为村里的村民带来了极大的生活和出行便利，进一步提升了村民的生活幸福感和满意度。”一盏盏路灯不仅照亮了山村的夜晚，更点亮了村民对美好生活的向往与信心。
          </div>
          <div class="big-ds">
            感恩同行，共筑光明
          </div>
          <div class="ds-ct">
            此次项目的顺利落地，离不开各爱心企业的慷慨支持与专业技术保障，也体现了公益组织与地方政府的高效协作。“地平线计划”将继续携手社会各界力量，把光与温暖送往更多有需要的乡村。 </div>

          <div class="big-ds">
            关于“地平线爱心计划”
          </div>
          <div class="ds-ct">
            作为贵州省为爱黔行公益服务中心的品牌项目之一，“点亮乡村振兴路”致力于通过公益力量改善偏远山区的夜间照明条件。自项目启动以来，已在贵州、云南、四川等地的深山村落安装了大量太阳能路灯，用科技的光芒驱散贫困的阴影，用实际行动践行“教育公平与社区陪伴”的机构使命。 </div>

          <div class="big-ds">
            写在最后
          </div>
          <div class="ds-ct">
            每一盏亮起的路灯，都是一个关于希望的故事。感谢所有支持“地平线爱心计划”的爱心人士与合作伙伴，是你们的善意，汇聚成了这照亮大山的星河。  </div>
          <div class="ds-ct">
            未来，我们将继续携手，让爱行走在更远的路上，点亮更多乡村振兴的希望之光。 </div>

        </div>
      </div>

    </div>

  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      statusBarHeight: 60,
    };

  },

  methods: {


    back() {
      window.history.back(-1);
    },
  },
  mounted() {


  },
};

</script>

<style lang="scss" scoped>
.new-layout {

  position: relative;

  .new-layout-bg {
    background: #F0F4FF;
    position: relative;

  }


  .correlation-new {
    background: #ffffff;
    padding: 10px;
    padding-bottom: 0;
    margin-top: 10px;


    .correlation-new-title {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      padding-top: 6px;
      //padding-bottom: 14px;
      font-size: 18px;
      font-weight: 500;
      color: #333333;

      .mark-view {
        height: 19px;
        width: 2px;
        border-radius: 5px;
        background: #3E74F8;
      }

      .dels {
        margin-left: 6px;
      }
    }
  }

  .new-content {

    background: #ffffff;
    color: #333333;
    padding-left: 12px;
    padding-right: 12px;
    padding-top: 12px;
    font-size: 14px;
    display: flex;
    justify-content: center;
    flex-direction: column;

    .box-xxt2 {
      padding-left: 2em;
      padding-top: 2px;
      padding-bottom: 2px;
      text-align: left;
    }


    .content {
      padding-top: 16px;
      padding-bottom: 16px;
      letter-spacing: 0;
      line-height: 26px;
      text-align: center;
      .big-ds{
        padding-top: 5px;
        padding-bottom: 5px;
        text-align: justify;
        font-weight: bold;
        font-size: 18px;
        color: #035cff;
      }

      .ds-ct {
        text-align: justify;
      }


      .new-icon {
        text-align: justify;
        width: 80%;
        border-radius: 10px;
        padding-top: 12px;
        padding-bottom: 12px;
      }

    }

    .title {
      margin-top: 30px;
      font-size: 20px;
      font-weight: bold;
    }

  }


}
</style>
